/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Header } from 'semantic-ui-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FeatureInfo } from '../Shared/FeatureInfo/FeatureInfo'


const PerformanceReportConfigurationHeader = () => {
    const [t] = useTranslation()

    return (
      <div>
          <Header
            css={css`
                display: inline;
                &.ui.header {
                    margin-right: .5rem;
                }
            `}
          >{t('reports.performance_configuration.create_a_report')}</Header>

          <FeatureInfo featureName='performance-report-configuration'>
              <FeatureInfo.Title>{t('reports.performance_configuration.feature_info.header')}</FeatureInfo.Title>
              <FeatureInfo.Text>{t('reports.performance_configuration.feature_info.subheader')}</FeatureInfo.Text>
              <FeatureInfo.List>
                  <FeatureInfo.ListItem>{t('reports.performance_configuration.feature_info.item1')}</FeatureInfo.ListItem>
                  <FeatureInfo.ListItem>{t('reports.performance_configuration.feature_info.item2')}</FeatureInfo.ListItem>
                  <FeatureInfo.ListItem>{t('reports.performance_configuration.feature_info.item3')}</FeatureInfo.ListItem>
              </FeatureInfo.List>
              <FeatureInfo.Text>{t('reports.performance_configuration.feature_info.footer')}</FeatureInfo.Text>
          </FeatureInfo>
      </div>
    )
}

export { PerformanceReportConfigurationHeader }
